module.exports = __webpack_public_path__ + "img/C-TD.b85c7be0.png";